const userKey = {
  all: ['user'] as const,
  getMyFavorite: () => [...userKey.all, 'favorite'] as const,
  getMyCreation: () => [...userKey.all, 'creation'] as const,
} as const;

export default userKey;
